import { Component, HostListener, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { LoadingComponent } from '@core/components/loading/loading.component';
import { ModalPromptComponent } from '@core/components/modal-prompt/modal-prompt.component';
import { ModalComponent } from '@core/components/modal/modal.component';
import { InactivityService } from '@core/services/inactivity.service';
import { environment } from '@environments/environment';
import { GoogleAnalyticsService } from '@core/services/google-analytics/google-analytics.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoadingComponent,
    ModalPromptComponent,
    ModalComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'Portal Oficina Virtual';

  constructor(
    private readonly inactivityService: InactivityService,
    private readonly router: Router,
    private readonly gAnalytics: GoogleAnalyticsService,
  ) {
    if (environment.production) {
      console.log(`
        ╔══════════════════════════════════════════════════════════════════════════════════════════╗
        ║                                   ✨ Oficina Virtual Info ✨                            ║
        ╠══════════════════════════════════════════════════════════════════════════════════════════╣
        ║                                                                                          ║
        ║    🚀 Version: ${environment.version}                                                               ║
        ║    🔱 Branch: ${environment.branch}                                                                 ║
        ║    📍  Commit: ${environment.commit}                                  ║
        ║    📆 Date: ${environment.date}                                              ║
        ║                                                                                          ║
        ╚══════════════════════════════════════════════════════════════════════════════════════════╝
        `);
    }
  }

  ngOnInit(): void {
    // Tracking de rutas con Google Analytics
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        const path = event.urlAfterRedirects;
        this.gAnalytics.trackPageView(path);
      });
  }

  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  handleUserActivity() {
    this.inactivityService.registerUserActivity();
  }
}
